<script setup lang="ts">
import {ExtendedProject, Role} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import ProjectLayout from "@/Pages/projects/layouts/ProjectLayout.vue";
import {route} from "ziggy-js";
import {Head, useForm} from "@inertiajs/vue3";
import TextField from "@/components/forms/TextField.vue";

interface Props {
    project: ExtendedProject,
    role: Role,
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})

const form = useForm({
    email: '',
    header: ''
})

const submit = () => {
    form.post(route('projects.subscriptions.store', {
        project: props.project.slug,
    }))
}
</script>

<template>
    <Head title="Configure email notifications" />
    <project-layout
        :role="props.role"
        :project="props.project"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            Email notifications
        </h1>
        <v-divider class="mt-3" />
        <v-card
            :flat="true"
            class="mb-5"
        >
            <v-form @submit.prevent="submit">
                <v-card-text class="px-0">
                    Setup email addresses to receive notifications when an transfer event is triggered.
                    <v-row class="mt-5">
                        <v-col
                            cols="12"
                            md="10"
                            class="py-0"
                        >
                            <text-field
                                v-model="form.email"
                                label="Address"
                                :required="true"
                                :errors="form.errors.email"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="10"
                            class="py-0"
                        >
                            <text-field
                                v-model="form.header"
                                label="Approved header"
                                :errors="form.errors.header"
                                hint="Sets the Approved header to automatically approve the message in a read-only or moderated mailing list."
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-0 mt-3">
                    <submit-btn
                        :loading="form.processing"
                        type="submit"
                    >
                        <span class="font-weight-bold">
                            Setup notifications
                        </span>
                    </submit-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </project-layout>
</template>

<style scoped>

</style>
